import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  RouteComponentProps,
  Redirect,
} from 'react-router-dom';

import { UserCapabilitiesContext } from './lib/UserCapabilities';

import { ComingSoon } from './comingsoon/ComingSoon';
import { Header } from './components/Header';
import Gallery from './pages/Gallery';
import Home from './pages/Home';
import MultiPostPage from './pages/MultiPostPage';
import Shop from './pages/Shop';

import { Category, parseCategory } from './data/Category';
import UserRoleProtected from './components/UserRoleProtected';
import { Clearance, LoginStatus, testLogin } from './data/sessionSlice';
import { AppConnectedProps } from './data/store';
import { connect } from 'react-redux';
import { State } from './data/rootReducer';
import { Press } from './pages/Press';

const connector = connect((state: State) => ({
  session: state.session,
}));

function AppRouter(props: AppConnectedProps<typeof connector>) {
  useEffect(() => {
    if (props.session.loginStatus === LoginStatus.UNKNOWN) {
      props.dispatch(testLogin());
    }
  });

  return (
    <Router basename="/">
      <Switch>
        <UserRoleProtected
          clearance={Clearance.Public}
          protectedStyle="none"
          fallback={
            <Route>
              {/* Default to coming soon */}
              <ComingSoon />
            </Route>
          }
        >
          <Route sensitive exact path="/walls">
            <Header backLink="/" page="walls" />
            <Gallery section="walls" key="walls" density="medium" />
          </Route>
          <Route sensitive exact path="/drawings">
            <Header backLink="/" page="drawings" />
            <Gallery section="drawings" key="drawings" density="medium" />
          </Route>
          <Route sensitive exact path="/sketches">
            <Header backLink="/" page="sketches" />
            <Gallery section="sketches" key="sketches" density="many" />
          </Route>
          <Route sensitive exact path="/tattoos">
            <Header backLink="/" page="tattoos" />
            <Gallery section="tattoos" key="tattoos" density="medium" />
          </Route>
          <Route sensitive exact path="/press">
            <Header backLink="/" page="press" />
            <Press />
          </Route>
          <Route
            sensitive
            exact
            path="/:category/:slug"
            render={({
              match,
            }: RouteComponentProps<{
              category: Category;
              slug: string;
            }>) => (
              <>
                <MultiPostPage
                  key={match.params.slug}
                  category={parseCategory(match.params.category)}
                  slug={match.params.slug}
                />
              </>
            )}
          />
          <Route sensitive exact path="/projects">
            <UserRoleProtected
              clearance={Clearance.InDevelopment}
              protectedStyle="none"
              fallback={<ComingSoon />}
            >
              <Header backLink="/" page="projects" />
              <Gallery section="projects" key="projects" density="few" />
            </UserRoleProtected>
          </Route>
          <Route sensitive exact path="/others">
            <UserRoleProtected
              clearance={Clearance.InDevelopment}
              protectedStyle="none"
              fallback={<ComingSoon />}
            >
              <Header backLink="/" page="others" />
              <Gallery section="others" key="others" density="few" />
            </UserRoleProtected>
          </Route>
          <Route sensitive path="/shop">
            <UserRoleProtected
              clearance={Clearance.InDevelopment}
              protectedStyle="none"
              fallback={<ComingSoon />}
            >
              <Shop />
            </UserRoleProtected>
          </Route>
          <Route sensitive exact path="/">
            <UserRoleProtected
              clearance={Clearance.Public}
              protectedStyle="none"
              fallback={<ComingSoon />}
            >
              {/* Default to home */}
              <UserCapabilitiesContext.Consumer>
                {(userCapabilities) =>
                  userCapabilities.isMobile() ? <Home layout="heads" /> : <Home layout="hands" />
                }
              </UserCapabilitiesContext.Consumer>
            </UserRoleProtected>
          </Route>
        </UserRoleProtected>
        {/* TODO: Handle bad category in URL */}
        {/* Redirect all else to home */}
        <Redirect to="/" />
      </Switch>
    </Router>
  );
}

export default connector(AppRouter);
